import { render, staticRenderFns } from "./WaterGear.vue?vue&type=template&id=187a1cd6"
import script from "./WaterGear.vue?vue&type=script&lang=js"
export * from "./WaterGear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports